import { TransmissionForPatientDtoIds, TransmissionStatusIds } from '@toktokdoctech/tokapi-client'
import TokTokDocDataTable from '../../Common/DataTable'
import PatientHistoryDownloadDocument from './PatientHistoryDownloadDocument'
import { PatientHistoryDownloadMedias } from './PatientHistoryDownloadMedias'
import useTTDFlag from '../../../hooks/useTTDFlag'
import { getFormatedDateWithHours, getFormatedShortDate, getTleHeaders, renderTransmissionState } from './_utils'
import { PatientTransmissionHistoryProps } from './_props'

const PatientTransmissionHistory = ({
    data,
    patient,
    isLoading,
    isError,
    page,
    itemsPerPage,
    handlePaginationChange,
    handleItemsPerPageChange,
}: PatientTransmissionHistoryProps) => {
    const isMinioEnabled = useTTDFlag('minio')

    if (isError) {
        return null
    }

    const describeRows = (row: TransmissionForPatientDtoIds) => {
        const dateTransmitted = row.transmissionDate ? getFormatedDateWithHours(row.transmissionDate) : ''
        const dateAnswerFull = row.acknowledgementDate ? getFormatedDateWithHours(row.acknowledgementDate) : ''
        const dateAnswerShort = row.acknowledgementDate ? getFormatedShortDate(row.acknowledgementDate) : ''

        const hasDoc = row.pictures.length > 0 || row.documents.length > 0 || row.videos.length > 0
        const result = [
            {
                item: dateTransmitted,
            },
            {
                item: dateAnswerFull,
            },
            {
                item: row?.target,
            },
            {
                item: renderTransmissionState(row.status, row.canceledBy),
            },
            {
                item: row.requiredExpert?.fullName,
            },
            {
                item: row.requiredExpert?.speciality ?? row.requiredExpert?.profession,
            },
            {
                item: isMinioEnabled && hasDoc && (
                    <PatientHistoryDownloadMedias actType="TRANSMISSION" item={row} type="medias" />
                ),
            },
            {
                item: row.status !== TransmissionStatusIds.Draft &&
                    row.prescription &&
                    row.prescription.downloadUrl && (
                        <PatientHistoryDownloadDocument
                            item={{
                                downloadUrl: row.prescription.downloadUrl,
                            }}
                            type="prescription"
                            fileName={`${patient.fullName}_${dateAnswerShort}_PRESCRIPTION`}
                        />
                    ),
            },
            {
                item: row.status !== TransmissionStatusIds.Draft && row.summary && (
                    <PatientHistoryDownloadDocument
                        item={{
                            downloadUrl: row.summary,
                            hasBeenRemoved: false,
                        }}
                        type="summary"
                        fileName={`${patient.fullName}_${dateAnswerShort}_CR`}
                    />
                ),
            },
        ]

        if (!isMinioEnabled) result.splice(6, 1)
        return result
    }

    return (
        <TokTokDocDataTable
            loading={isLoading}
            page={page}
            itemsPerPage={itemsPerPage}
            count={data?.total}
            handlePaginationChange={handlePaginationChange}
            handleItemsPerPageChange={handleItemsPerPageChange}
            headers={getTleHeaders(isMinioEnabled)}
            headerCellsSize="small"
            items={data?.items ?? []}
            describeRows={describeRows}
        />
    )
}

export default PatientTransmissionHistory
